import {Component, OnInit} from '@angular/core';
import {NavService} from '../../_services/_nav.service';
import {Segmento} from '../../_models/segmento';
import {SegmentosService} from '../../_services/segmentos.service';
import {Router} from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component({
  templateUrl: 'segmento-listado.component.html',
  selector: 'app-segmentos',
})
export class SegmentoListadoComponent implements OnInit {

  columnas: any[];
  busqueda: string;
  segmentos: Segmento[];
  carSegmentos: boolean;
  menu: Funcionalidad = new Funcionalidad();

  constructor(private navServicio: NavService,
              private router: Router,
              private autServicio: AutenticacionService,
              private segmentosService: SegmentosService) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/segmentos' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      {field: 'codigo', header: this.navServicio.buscarMensaje('SEGMENTOS.LBL_CODIGO'), sort: true},
      {field: 'nombre', header: this.navServicio.buscarMensaje('SEGMENTOS.LBL_SEGMENTO'), sort: true},
      {field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje('SEGMENTOS.LBL_HABILITADO'), sort: true},
      {field: 'det', header: this.navServicio.buscarMensaje('SEGMENTOS.LBL_ACCIONES'), sort: true},
    ];
    this.carSegmentos = true;
    this.segmentosService.listado().subscribe(res => {
      this.carSegmentos = false;
      this.segmentos = res;
    }, e => {
      this.carSegmentos = false;
      console.error(e.message);
    });
  }

  add(): void {
    this.router.navigate(['apl/segmentos/agregar']);
  }

  update(segmento: Segmento): void {
    this.router.navigate(['apl/segmentos/actualizar/' + segmento.idSegmento]);
  }

  view(segmento: Segmento): void {
    this.router.navigate(['apl/segmentos/detalle/' + segmento.idSegmento]);
  }

  setSearch(): void {
    this.navServicio.setSearch('roles.component', this.busqueda);
  }

}
